export default "__VITE_ASSET__D$0PHZmH__"